import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getOrder, updateOrder } from '../services/api';

const OrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrderDetails = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getOrder(id);
      setOrder(response.data);
    } catch (err) {
      console.error('Erreur détaillée:', err);
      setError('Erreur lors du chargement des détails de la commande');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchOrderDetails();
  }, [fetchOrderDetails]);

  const handleStatusChange = async (newStatus) => {
    try {
      setError(null);
      if (!order) throw new Error('Commande non trouvée');

     

      await updateOrder(id, newStatus);
      await fetchOrderDetails();
    } catch (err) {
      console.error('Erreur détaillée:', err);
      setError(err.response?.data?.message || 'Erreur lors de la mise à jour du statut');
    }
  };

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case 'PENDING':
        return 'bg-yellow-100 text-yellow-800';
      case 'PREPARING':
        return 'bg-green-100 text-green-800';
      case 'READY':
        return 'bg-red-100 text-red-800';
          case 'SERVED':
        return 'bg-green-100 text-green-800';
      case 'CANCELED':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };


  const calculateTotal = (orderItems) => {
    if (!orderItems || !Array.isArray(orderItems)) return 0;
    return orderItems.reduce((total, item) => {
      return total + (item.quantity * (item.menuItem?.price || 0));
    }, 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  if (loading) return (
    <div className="flex justify-center items-center h-screen bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-amber-600 mx-auto"></div>
        <p className="mt-4 text-lg text-gray-600">Chargement des détails...</p>
      </div>
    </div>
  );

  if (error) return (
    <div className="container mx-auto p-6 max-w-4xl">
      <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 rounded-lg shadow-sm">
        <p className="font-semibold">Erreur</p>
        <p>{error}</p>
        <button
          onClick={fetchOrderDetails}
          className="mt-4 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
        >
          Réessayer
        </button>
      </div>
    </div>
  );

  if (!order) return (
    <div className="container mx-auto p-6 max-w-4xl">
      <div className="bg-yellow-50 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded-lg shadow-sm">
        <p className="font-semibold">Commande non trouvée</p>
      </div>
    </div>
  );

  return (
    <div className="container mx-auto p-6 max-w-4xl">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Commande #{order.id}</h1>
        <button
          onClick={() => navigate('/orders')}
           className="bg-amber-600 text-black px-6 py-2 rounded-lg hover:bg-amber-700 transition-colors flex items-center gap-2"
             
  style={{ backgroundColor: '#fdf54d' }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            
          </svg>
          Retour
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8">
          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-6">Informations</h2>
            <div className="space-y-6 bg-gray-50 p-6 rounded-lg border border-gray-200">
              <div>
                <label className="block text-sm font-medium text-gray-600">Date de création</label>
                <p className="mt-1 text-gray-900 font-medium">{formatDate(order.createdAt)}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Table</label>
                <p className="mt-1 text-gray-900 font-medium">
                  Table #{order.table?.tableNumber ?? 'Non assignée'}
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Statut</label>
                <select
                  value={order.status}
                  onChange={(e) => handleStatusChange(e.target.value)}
                  className={`mt-2 block w-full px-4 py-2 text-base border rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 ${getStatusBadgeColor(order.status)} transition-colors`}
                >
           <option value="PENDING">En attente</option>
<option value="PREPARING">En préparation</option>
<option value="READY">Prête</option>
<option value="SERVED">Terminée</option>
<option value="CANCELED">Annulée</option>

                </select>
              </div>
            </div>
          </div>
 
          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-6">Articles commandés</h2>
            <div className="overflow-x-auto border border-gray-200 rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Article</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Qté</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Prix</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Total</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {order.orderItem?.length > 0 ? (
                    order.orderItem.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 text-sm text-gray-900">
                          {item.menuItem?.name || 'Article sans nom'}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900">
                          {item.quantity || 1}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900">
                          {(item.menuItem?.price || 0).toFixed(2)}(MAD)
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900">
                          {(item.quantity * (item.menuItem?.price || 0)).toFixed(2)}(MAD)
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
                        Aucun article dans cette commande
                      </td>
                    </tr>
                  )}
                </tbody>
                {order.orderItem?.length > 0 && (
                  <tfoot className="bg-gray-100">
                    <tr>
                      <td colSpan="3" className="px-6 py-4 text-right text-sm font-semibold text-gray-800">
                        Total :
                      </td>
                      <td className="px-6 py-4 text-sm font-semibold text-gray-800">
                        {calculateTotal(order.orderItem).toFixed(2)}(MAD)
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;